import React from "react"
import styles from "./artist-detail-text"
import classNames from "classnames/bind"

const cx = classNames.bind(styles)

export default ({ text }) => <p className={cx("text")}>{text}</p>
